export default "{\n    \"heading\": \"Menú diario\"\n}"